import React from 'react'
import style from './style.module.less'
export default ({
  index,
  maxLength,
  onMoveUp,
  onMoveDown,
  onCopy,
  onAddText,
  onDelete,
  panelStyle
}) => (
  <div className={style.image_operate} style={panelStyle}>
    {onMoveUp && (
      <span
        className={`${style.image_operate__item} ${
          index == 0 ? style.up : style.up_active
        }`}
        onClick={onMoveUp}
      />
    )}
    {onMoveDown && (
      <span
        className={`${style.image_operate__item} ${
          index == maxLength - 1 ? style.down : style.down_active
        }`}
        onClick={onMoveDown}
      />
    )}
    {onCopy && (
      <span
        className={`${style.image_operate__item} ${
          style.copy
        } iconfont icon-fuzhi`}
        onClick={onCopy}
      />
    )}
    {onAddText && (
      <span
        className={`${style.image_operate__item} ${style.addtext}`}
        onClick={onAddText}
      />
    )}
    {onDelete && (
      <span
        className={`${style.image_operate__item} ${style.remove}`}
        onClick={onDelete}
      />
    )}
  </div>
)
